import request from '@/utils/request.js';
import { getUserLngLat } from '@/utils/geo'
const withUserLngLat = (body = {}) => {
  const payload = { ...(body || {}) }
  const geo = getUserLngLat()
  if (geo && typeof payload.lng === 'undefined') payload.lng = geo.lng
  if (geo && typeof payload.lat === 'undefined') payload.lat = geo.lat
  return payload
}
export function getCategoryList(params) {
    return request({
        url: "/api/service.service/category_list",
        method: "get",
        params
      });
}
// 获取用户详情（账号设置）
export function getUserDetail(params = {}) {
  return request({
    url: "/api/user.index/detail",
    method: "get",
    params
  });
}
// 修改密码
export function editPassword(data){
  // 后端要求：multipart/form-data
  // POST http://www.hwm.red/index.php/api/user.user/edit_password?app_id=10001&token=xxx
  // Body: old_password/password/confirm_password/app_id
  const form = new FormData()
  const payload = data || {}
  Object.keys(payload).forEach((k) => {
    if (typeof payload[k] === 'undefined' || payload[k] === null) return
    form.append(k, payload[k])
  })
  form.append('app_id', 10001)
  return request({
    // 走本地 devServer 代理（vue.config.js: /api -> http://www.hwm.red/index.php），避免浏览器 CORS
    // 生产环境若不走同域/网关代理，需要后端开启 CORS
    url: "/api/user.user/edit_password",
    method: "post",
    data: form
  });
}
// 修改用户信息（Avatar、Nickname、Email）
export function updateUserInfo(data){
  return request({
    url: "/api/user.user/updateInfo",
    method: "post",
    data
  });
}
export function register(data){
  // 后端注册接口使用 multipart/form-data，显式携带 confirm_password
  const form = new FormData()
  const payload = data || {}
  ;['mobile', 'password', 'confirm_password', 'code', 'email', 'app_id'].forEach((k) => {
    if (typeof payload[k] === 'undefined' || payload[k] === null) return
    form.append(k, payload[k])
  })
  return request({
    url: "/api/user.user/register",
    method: "post",
    data: form
  });
}
// 重置密码
export function resetPassword(data){
  // 后端要求：multipart/form-data
  // POST /api/user.user/reset_password?app_id=10001&token=xxx
  // Body: mobile/password/code/app_id
  const form = new FormData()
  const payload = data || {}
  Object.keys(payload).forEach((k) => {
    if (typeof payload[k] === 'undefined' || payload[k] === null) return
    form.append(k, payload[k])
  })
  form.append('app_id', 10001)
  return request({
    url: "/api/user.user/reset_password",
    method: "post",
    data: form
  });
}
// 发送验证码（注册/忘记密码）
// POST /api/user.userOpen/sendCode?mobile=xxx&app_id=10001&token=xxx
// 注意：app_id/token 由 request 拦截器自动注入，这里只传 mobile
export function sendCode(params){
  return request({
    url: "/api/user.userOpen/sendCode",
    method: "post",
    params
  });
}
// 获取注册页相关配置（Terms of Service/Privacy Policy等）
// 后端：GET /api/user.user/register 返回 service_terms/privacy_policy
export function getRegisterAgreements(params = {}){
  return request({
    url: "/api/user.user/register",
    method: "get",
    params
  });
}
// 我的评价列表
// 后端：POST /api/user.comment/my_list
// 注：后端示例为 multipart/form-data，这里使用 FormData 兼容
export function getMyCommentList(data = { app_id: 10001 }){
  const form = new FormData()
  Object.keys(data || {}).forEach((k) => {
    if (typeof data[k] === 'undefined' || data[k] === null) return
    form.append(k, data[k])
  })
  return request({
    url: "/api/user.comment/my_list",
    method: "post",
    data: form
  });
}
export function getSupplierList(data){
  return request({
    url: "/api/service.service/supplier_list",
    method: "post",
    data: withUserLngLat(data)
  });
}
export function getSupplierDetail(params){
  return request({
    url: "/api/service.service/supplier_detail",
    method: "get",
    params
  });
}
export function getAvailableTechnicians(data){
  return request({
    url: "/api/technician.technician/getAvailableTechnicians",
    method: "post",
    data
  });
}
// 批量获取每项服务可选择的技师。
export function getServiceTechnicians(data){
  return request({
    url: "/api/technician.technician/getServiceTechnicians",
    method: "post",
    data
  });
}
// 获取指定日期的完整预约时间网格。
export function getBookingCalendar(data){
  return request({
    url: "/api/technician.technician/getBookingCalendar",
    method: "post",
    data
  });
}
export function getOrderList(data){
  return request({
    url: "/api/user.service_order/list",
    method: "post",
    data: withUserLngLat(data)
  });
}
export function getOderConfirm(data){
  return request({
    url: `/api/order.service_order/confirm`,
    method: "post",
    data
  });
}
// 获取服务订单最终报价
export function quoteServiceOrder(data){
  return request({
    url: `/api/order.service_order/quote`,
    method: "post",
    data
  });
}
// 获取订单列表
// export function getOrderList(data){
//   data.app_id = 10001
//   data.token = getToken() || ''
//   return request({
//     url: `/api/user.service_order/list`,
//     method: "post",
//     data
//   });
// }
// 收藏店铺
export function getShopFavorite(data){
  return request({
    url: `/api/user.Favorite/add`,
    method: "post",
    data
  })
}
// 获取收藏列表
export function getFavoriteList(data){
  return request({
    url: `/api/user.Favorite/list`,
    method: "post",
    data
  })
}
// 立即Book下单
export function payOrder(data){
  return request({
    url: `/api/order.service_order/book`,
    method: "post",
    data
  })
}
// 获取订单详情
export function getOrderDetail(params){
  return request({
    url: `/api/user.service_order/detail`,
    method: "post",
    data: withUserLngLat(params)
  })
}
// 取消 Order
export function cancelOrder(data){
  return request({
    url: `/api/user.service_order/cancel`,
    method: "post",
    data
  })
}
export function uploadFile(data){
  return request({
    url: `/api/file.upload/image`,
    method: "post",
    data,
  })
}
export function reFundApply(data){
  return request({
    url: `/api/user.service_refund/apply`,
    method: "post",
    data,
  })
}
// 获取申请状体
export function getSupplierApplyStatus(data){
  return request({
    url: `/api/supplier.apply/detail`,
    method: "post",
    data,
  })
}
// 申请成为商家
export function getSupplierApplyIndex(data){
  return request({
    url: `/api/supplier.apply/index`,
    method: "post",
    data,
  })
}
// 获取售后 订单列表
export function getServiceRefundList(params){
  return request({
    url: `/api/user.service_refund/lists`,
    method: "post",
    data: withUserLngLat(params)
  })
}
// 获取售后订单详情
export function getServiceRefundDetail(params){
  return request({
    url: `/api/user.service_refund/detail`,
    method: "post",
    data: withUserLngLat(params)
  })
}
// Request Platform Intervention（售后）
// GET /api/user.service_refund/plateapply?order_refund_id=xx
export function serviceRefundPlateApply(params){
  return request({
    url: `/api/user.service_refund/plateapply`,
    method: "get",
    params
  })
}
// 提交评价
export function getCommentOrder(data){
  return request({
    url: `/api/user.comment/order`,
    method: "post",
    data
  })
}
// 获取商家评价
export function getSupplierComment(data){
  return request({
    url: `/api/supplier.index/getSupplierComment`,
    method: "post",
    data
  })
}
// 获取店铺技师展示列表
export function getSupplierTechnician(data){
  return request({
    url: `/api/supplier.index/getSupplierTechnician`,
    method: "post",
    data
  })
}
// 获取My 礼品卡s列表
export function getUserGiftCardList(data){
  return request({
    url: `/api/supplier.giftCard/getUserGiftCardList`,
    method: 'post',
    data
  })
}
// 绑定礼品卡
export function bindGiftCard(data){
  return request({
    url: `/api/supplier.giftCard/bindGiftCard`,
    method: 'post',
    data
  })
}
// 获取原始买家的礼品卡 PIN
export function getUserGiftCardPin(params){
  return request({
    url: `/api/supplier.giftCard/getUserGiftCardPin`,
    method: 'post',
    params
  })
}
// 解绑礼品卡
export function unbindGiftCard(params){
  return request({
    url: `/api/supplier.giftCard/unbindGiftCard`,
    method: 'post',
    params
  })
}
// 获取礼品卡详情
export function getCardDetail(params){
  return request({
    url: `/api/supplier.index/getCardDetail`,
    method: 'get',
    params
  })
}
// 获取店铺礼品卡列表
export function getSupplierCard(data){
  return request({
    url: `/api/supplier.index/getSupplierCard`,
    method: 'post',
    data
  })
}
// 获取用户礼品卡详情
export function getUserGiftCardDetail(params){
  return request({
    url: `/api/supplier.giftCard/getUserGiftCardDetail`,
    method: 'post',
    params
  })
}
// 订单待支付支付
// 创建礼品卡订单（Stripe Checkout）
// 后端要求：query 传 token（由 request 拦截器自动注入）+ gift_card_id + success_url + cancel_url + app_id
export function createGiftCardOrder(params){
  return request({
    url: `/api/supplier.giftCard/createGiftCardOrder`,
    method: 'post',
    params
  })
}
// 搜索礼品卡 Payment状态
// 后端要求：query 传 token（由 request 拦截器自动注入）+ order_id/order_no + app_id
export function getGiftCardPayStatus(params){
  return request({
    url: `/api/supplier.giftCard/getGiftCardPayStatus`,
    method: 'post',
    params
  })
}
export function orderPay(data){
  return request({
    url: `/api/order.service_order/pay`,
    method: 'post',
    data
  })
}
